import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import styles from 'assets/styles/training.module.scss';
import styles_ from './SkillPaths.module.scss';
import 'react-circular-progressbar/dist/styles.css';
import Shimmer from '../Shimmer';
import { format, parseISO } from 'date-fns';
import ResumeChart from './ResumeChart';
import RepSkillPathChart from './RepSkillPathChart';
import {
  useGetSkillPathYourProgress,
  useGetSkillPathsResume,
  useGetSkillPathsHistory,
} from 'features/training/Training.queries';
import { useLearningPathsStore } from '../LearningPaths/LearningPaths.store';
import AssignedLearningPathDetails from '../LearningPaths/Components/AssignedLearningPathDetails/AssignedLearningPathDetails';
import { CustomButton } from 'shared_ui_components';

const SkillPathsDashboardRep = ({ ff_skill_paths_dashboards = false }) => {
  const [count, setCount] = useState(1);
  const { selectedRepLearningPathID, setSelectedRepLearningPathID } = useLearningPathsStore();

  const { data: skillPathYourProgress = {}, isLoading: isLoadingGetSkillPathsYourProgress } =
    useGetSkillPathYourProgress({
      enabled: ff_skill_paths_dashboards,
    });
  const { data: skillPathsResume = {}, isLoading: isLoadingSkillPathsResume } =
    useGetSkillPathsResume({
      enabled: ff_skill_paths_dashboards,
    });

  const {
    data: skillPathsHistory = {},
    isLoading: isLoadingSkillPathsHistory,
    refetch: refetchSkillPathsHistory,
    isFetching: isFetchingSkillPathsHistory,
  } = useGetSkillPathsHistory({
    enabled: ff_skill_paths_dashboards,
    page: count,
  });
  useEffect(() => {
    refetchSkillPathsHistory();
  }, [count]);

  const handleViewMore = () => {
    setCount((prevCount) => prevCount + 1);
  };
  const handleBack = () => {
    setCount((prevCount) => prevCount - 1);
  };
  useEffect(() => {
    return () => {
      setSelectedRepLearningPathID('');
    };
  }, [setSelectedRepLearningPathID]);

  if (isLoadingGetSkillPathsYourProgress || isLoadingSkillPathsResume || isLoadingSkillPathsHistory)
    return (
      <div>
        {' '}
        <Shimmer type="ModuleCard" />
      </div>
    );

  if (selectedRepLearningPathID)
    return <AssignedLearningPathDetails uuid={selectedRepLearningPathID} />;

  return (
    <>
      <br />
      <Grid container spacing={1}>
        <Grid item md={6} lg={6} xs={12}>
          <ResumeChart
            title={skillPathsResume?.data?.learning_path?.title}
            skillPath={{ ...skillPathsResume?.data }}
            due={skillPathsResume?.data?.learning_path?.deadline}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12}>
          {Object.keys(skillPathYourProgress).length > 0 && (
            <RepSkillPathChart
              title={`Skill Paths`}
              progress={{ ...skillPathYourProgress?.data }}
            />
          )}
        </Grid>
      </Grid>
      <br />
      <section className={`${styles.moduleDetails} dashboardListing`}>
        {Object.keys(skillPathsHistory?.data?.data?.learning_paths).length > 0 ? (
          <Grid container direction="row">
            <Grid md={12}>
              <div className="teamProgressWrapper">
                <Grid container direction="row" spacing={4} className="headingRow">
                  <Grid item md={5}>
                    <h3 className="heading5">Skill Path History</h3>
                  </Grid>
                </Grid>
                <div className="teamProgressDetail">
                  <Grid container direction="row" spacing={4} className="titleRow">
                    <Grid container item md={6}>
                      <Grid item md={5}>
                        <h6 className="supportTextSemibold">NAME</h6>
                      </Grid>
                      <Grid item md={4}>
                        <h6 className="supportTextSemibold">AUTHOR</h6>
                      </Grid>
                      <Grid item md={3}>
                        <h6 className="supportTextSemibold">SKILL SETS</h6>
                      </Grid>
                    </Grid>
                    <Grid container item md={6}>
                      <Grid item md={3}>
                        <h6 className="supportTextSemibold">UPDATED DATE</h6>
                      </Grid>
                      <Grid item md={3}>
                        <h6 className="supportTextSemibold">DUE</h6>
                      </Grid>
                      <Grid item md={3}>
                        <h6 className="supportTextSemibold">COMPLETION DATE</h6>
                      </Grid>
                      <Grid item md={3}>
                        <h6 className="supportTextSemibold">STATUS</h6>
                      </Grid>
                    </Grid>
                  </Grid>
                  <div className="contentBlock">
                    {skillPathsHistory?.data?.data?.learning_paths?.map((skillPath) => (
                      <SkillPathRegister skillPath={skillPath} key={skillPath.id} />
                    ))}
                  </div>
                  {skillPathsHistory?.data?.data?.pagination?.next ||
                  skillPathsHistory?.data?.data?.pagination?.previous ? (
                    <div className={styles.viewMoreBtn}>
                      <p className={styles_.navigationButton} style={{ margin: '24px 0 8px' }}>
                        {skillPathsHistory?.data?.data?.pagination?.previous && (
                          <CustomButton className="secondaryBtn" onClick={handleBack}>
                            {isFetchingSkillPathsHistory ? 'Loading...' : 'Previous Page'}
                          </CustomButton>
                        )}
                        {skillPathsHistory?.data?.data?.pagination?.next && (
                          <CustomButton className="secondaryBtn" onClick={handleViewMore}>
                            {isFetchingSkillPathsHistory ? 'Loading...' : 'Next Page'}
                          </CustomButton>
                        )}
                      </p>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        ) : (
          <div className={styles_.noSkillPathHistory}>
            <div>Your Skill Path History will show here</div>
          </div>
        )}
      </section>
    </>
  );
};

export function SkillPathRegister(props) {
  const { skillPath = {} } = props;

  return (
    <div className="item">
      <Grid container direction="row" spacing={4} className="item">
        <Grid container item md={6}>
          <Grid item md={5}>
            <h6 className="supportTextSemibold">{skillPath?.title}</h6>
          </Grid>
          <Grid item md={4}>
            <h6 className="supportTextSemibold">{skillPath?.author}</h6>
          </Grid>
          <Grid item md={3}>
            <h6 className="supportTextSemibold">{skillPath?.modules_count}</h6>
          </Grid>
        </Grid>
        <Grid container item md={6}>
          <Grid item md={3}>
            <h6 className="supportTextSemibold">
              {format(parseISO(skillPath?.updated_at), 'dd/MM/yyyy')}
            </h6>
          </Grid>
          <Grid item md={3}>
            <h6 className="supportTextSemibold">
              {format(parseISO(skillPath?.deadline), 'dd/MM/yyyy')}
            </h6>
          </Grid>
          <Grid item md={3}>
            <h6 className="supportTextSemibold">
              {skillPath?.completed_at
                ? format(parseISO(skillPath?.completed_at), 'dd/MM/yyyy')
                : '- -'}
            </h6>
          </Grid>
          <Grid item md={3}>
            <h6
              className={
                skillPath?.status.key === 'completed'
                  ? styles_.completedStatus
                  : skillPath?.status.key === 'in_progress'
                  ? styles_.in_progress
                  : styles_.not_started
              }
            >
              {skillPath?.status.label}
            </h6>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default SkillPathsDashboardRep;
